import * as types from "../types";
import backend from "../api/api";
import history from "../history";
import { store } from "../store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createUserRole = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/contact/user-role/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_USER_ROLE,
        payload: { ...response.data },
      });
      message.success("Updated Successfully");
      history.push("/user-role");
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllUserRole = () => async (dispatch) => {
  try {
    const response = await backend.get("api/contact/user-role/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_USER_ROLE,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteUserRole = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/contact/user-role/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_USER_ROLE, payload: id });
    }
    history.push("/user-role");
  } catch (error) {
    alert(error);
  }
};

export const updateUserRole = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/contact/user-role/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_USER_ROLE, payload: { ...response.data } });
    }
    message.success("Updated Successfully");
    history.push("/user-role");
  } catch (error) {
    alert(error.response);
  }
};